// @MX:NOTE: china-inapi 이관 완료 — 이 팩토리의 $axios 에는 chinaInapi 인스턴스가 주입된다
//   (CertificateList.vue / CertificateDetailModal.vue). 아래 두 EP 는
//   SPEC-CHINA-ADMIN-CERT-FOLLOWER-EP-001 §5.5 동결 경로다 (AccessTokenGuard + TenantGuard).
//   레거시 한국 inapi 경로(POST /nfts/manufacturer/list/v2, POST /nfts/received)는 더 이상 사용하지 않는다.
//   목록은 레거시 POST(body) → 신규 GET(query) 로 메서드가 전환됐다 (SPEC M3 범위, D2/N2).
//   (SPEC-CHINA-ADMIN-CERT-FOLLOWER-EP-001 M3, 2026-07-27)
const CERT_BASE = '/products/admin/dentium/china/certifications';

export default ($axios) => ({
  // 인증서 목록 조회 — 신규 EP 는 query 파라미터(GET). 응답 { items, paginator } (success 래퍼 없음)
  getCertificateList: (params) => {
    return $axios.get(CERT_BASE, { params });
  },
  // 인증서 상세 조회 — 신규 EP 는 snsType 을 소비하지 않으므로 전달하지 않는다.
  //   응답 { status, resultMessage: [...] } (레거시 패리티, companyName·createAt 포함)
  getCertificateDetail: (id) => {
    return $axios.post(`${CERT_BASE}/received`, {
      nftIds: [id]
    });
  },
  // 인증서 통계 조회 — 목록 페이지 상단 통계 섹션(CertStatsSection.vue) 전용.
  //   응답 { total, today, last7Days, thisMonth, prevMonth, daily[], monthly[], timezone } (success 래퍼 없음)
  //   manufacturerId 는 XINLAIAN 전용 좁히기 파라미터, 제조사 계정이 보내도 백엔드가 무시한다.
  getCertificateStats: (params) => {
    return $axios.get(`${CERT_BASE}/stats`, { params });
  }
});
